import { createContext } from "react"

import type { Notifier } from "@airbrake/browser"

const defaultValue: {
  airbrake: Notifier | null
} = {
  airbrake: null,
}

export const AirbrakeContext = createContext(defaultValue)
